import { render, staticRenderFns } from "./imgVerify.vue?vue&type=template&id=6b12dab3&scoped=true"
import script from "./imgVerify.vue?vue&type=script&lang=js"
export * from "./imgVerify.vue?vue&type=script&lang=js"
import style0 from "./imgVerify.vue?vue&type=style&index=0&id=6b12dab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12dab3",
  null
  
)

export default component.exports